import { imgPos } from "@/lib/utils";

const toSrc = (u) => (u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

const FramingTile = ({ url, index, pos, onSet, onReset, custom }) => {
  const [x, y] = pos.split(" ").map((v) => parseFloat(v));
  const update = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = Math.round(Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100)));
    const py = Math.round(Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100)));
    onSet(`${px}% ${py}%`);
  };
  return (
    <div data-testid={`admin-framing-tile-${index}`}>
      <div
        data-testid={`admin-framing-area-${index}`}
        onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); update(e); }}
        onPointerMove={(e) => { if (e.buttons) update(e); }}
        className="relative rounded-lg overflow-hidden bg-white cursor-crosshair touch-none select-none ring-1 ring-[#F1DCC5]"
      >
        <img src={toSrc(url)} alt="" draggable={false} className="w-full h-auto block pointer-events-none" />
        <div
          className="absolute w-5 h-5 -ml-2.5 -mt-2.5 rounded-full border-2 border-white shadow-[0_0_0_2px_rgba(0,0,0,0.5)] bg-[var(--gl-orange)]/70 pointer-events-none"
          style={{ left: `${x}%`, top: `${y}%` }}
        />
      </div>
      <div className="mt-2 flex items-end gap-2">
        <div className="w-1/2 aspect-[3/4] rounded overflow-hidden ring-1 ring-[#F1DCC5]" data-testid={`admin-framing-preview-${index}`}>
          <img src={toSrc(url)} alt="" draggable={false} style={{ objectPosition: pos }} className="w-full h-full object-cover" />
        </div>
        <span className="text-[9px] font-badge tracking-widest text-[#8A7568]">SHOP PREVIEW</span>
      </div>
      <div className="flex items-center justify-between mt-1 text-[10px] text-[#8A7568]">
        <span data-testid={`admin-framing-value-${index}`}>{custom ? pos : "Top (default)"}</span>
        {custom && (
          <button type="button" data-testid={`admin-framing-reset-${index}`} onClick={onReset} className="underline hover:text-[#241C18]">
            Reset
          </button>
        )}
      </div>
    </div>
  );
};

export const ImageFramingEditor = ({ product, onChange }) => {
  const images = product.images || [];
  const positions = product.image_positions || {};
  if (!images.length) return null;
  const setPos = (url, value) => {
    const next = { ...positions };
    if (value) next[url] = value;
    else delete next[url];
    onChange(next);
  };
  return (
    <div className="col-span-2" data-testid="admin-framing-editor">
      <div className="text-xs font-badge text-[#8A7568]">Photo framing</div>
      <div className="text-[11px] text-[#8A7568] mb-2">
        Tap or drag on the full photo to mark what must always stay visible (e.g. the face) — the small preview shows how it will look in the shop. By default photos are anchored to the top, so only the bottom gets cropped.
      </div>
      <div className="grid grid-cols-3 md:grid-cols-5 gap-2">
        {images.map((url, i) => (
          <FramingTile
            key={`${url}-${i}`}
            url={url}
            index={i}
            pos={imgPos(product, url)}
            custom={Boolean(positions[url])}
            onSet={(v) => setPos(url, v)}
            onReset={() => setPos(url, null)}
          />
        ))}
      </div>
    </div>
  );
};
